import { bbAxios } from '@bb/session-manager';

import {
  TRAINING_ATTRIBUTES_ENDPOINT,
  TRAINING_CREATE_FROM_ZIP_ENDPOINT,
  TRAINING_PREVIEW_ENDPOINT,
} from '../endpoints.config';

export async function CreateFromZip(id, data, file) {
  const fd = new FormData();
  fd.append('files', file);
  Object.entries(data).forEach(([k, v]) => fd.append(k, v));
  fd.append('model', id);
  const response = await bbAxios.put(TRAINING_CREATE_FROM_ZIP_ENDPOINT, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  if (response.status !== 200) {
    throw Error('Failed to create training data from zip');
  }
}

export function GetUniqueAttributes(modelId) {
  return bbAxios
    .get(`${TRAINING_ATTRIBUTES_ENDPOINT}/${modelId}`)
    .then((resp) => resp?.data)
    .catch((err) => {
      console.error(err);
      throw Error('Failed to get training attributes');
    });
}

export async function fetchEditPreviews(trainingRuleIds) {
  try {
    const { data } = await bbAxios.get(`${TRAINING_PREVIEW_ENDPOINT}`, {
      params: { trainingRuleIds },
    });
    return data;
  } catch (err) {
    console.error(
      `Problem with fetching previews for trainingRuleIds ${trainingRuleIds}:`,
      err
    );
  }
}
